import React, { useState } from 'react';
import PropTypes from 'prop-types';
// TODO: Do it in-house and move it to components/v2
import ChipInput from 'material-ui-chip-input';

import { withStyles } from '@material-ui/core/styles';
import { ClickAwayListener, MenuItem, MenuList, Paper } from '@material-ui/core';

import Chip from '../Chip';

const styles = ({ custom: { fontSizes }, spacing: { unit } }) => ({
  chipContainer: {
    marginTop: `${unit * 3}px !important`,
    marginBottom: unit / 2,
  },
  chip: {
    margin: `4px ${unit / 2}px`,
    fontSize: fontSizes.small,
  },
});

const ChipInputField = ({ classes, tags, input }) => {
  const [open, setOpen] = useState(false);
  const [localTags, setLocalTags] = useState([]);

  const handleDeleteTags = (tag) => {
    const remainingTags = localTags.filter((localTag) => localTag !== tag);
    setLocalTags(remainingTags);
    input.onChange(remainingTags);
  };

  const handlePickTags = (tag) => {
    const lowerCaseTag = tag.toLowerCase();
    // Unique tags
    const pickedTags = Array.from(new Set([...localTags, lowerCaseTag]));
    setLocalTags(pickedTags);
    input.onChange(pickedTags);
  };

  return (
    <>
      <ChipInput
        classes={{
          chipContainer: classes.chipContainer,
        }}
        chipRenderer={({ value, handleDelete }) => (
          <Chip
            className={classes.chip}
            color="supportPowder"
            onClick={() => handleDelete(value)}
            label={value}
            selected
            square
          />
        )}
        InputLabelProps={{
          shrink: true,
        }}
        onClick={() => setOpen(true)}
        onAdd={(tag) => handlePickTags(tag)}
        onDelete={(tag) => handleDeleteTags(tag)}
        placeholder="Type tag and hit enter"
        label="Tags"
        value={localTags}
        fullWidth
      />
      {open && tags.length > 0 && (
        <Paper square>
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <MenuList>
              {tags.map((tag) => (
                <MenuItem key={tag} value={tag} onClick={() => handlePickTags(tag)}>
                  {tag}
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      )}
    </>
  );
};

ChipInputField.propTypes = {
  classes: PropTypes.object,
  input: PropTypes.object.isRequired,
  tags: PropTypes.array.isRequired,
};

export default withStyles(styles)(ChipInputField);
